import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router'

import 'styles/reset.css'

import styles from './styles.scss'

const PublicPages = (props) => {
  const { children } = props

  return <div className={styles.root}>{children}</div>
}

PublicPages.propTypes = {
  children: PropTypes.object,
}

export default withRouter(PublicPages)
